module.exports = __webpack_public_path__ + "static/media/image-768.c46710ee.webp";